module.exports = __webpack_public_path__ + "static/img/oval@3x.bb23476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oval@3x.png
// module id = lxIO
// module chunks = 6